import React, { useRef } from "react";
import "aos/dist/aos.css";
import { MailIcon, PhoneIcon } from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import drivado_logo from "../../assets/drivado_logo.png";
import MyVideo from "../../assets/images/video.jpg";
import { faEnvelope, faPhone } from "@fortawesome/fontawesome-free-solid";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <>
      <div className="text-white text-left bg-black w-full h-[520px] md:h-[450px] lg:h-[440px] pt-2 space-y-2">
        {/* ---------------------- MOBILE VIEW ---------------------------- */}
        <div className="inline md:hidden">
          <h2 className="text-sm font-semibold text-center text-white pt-2 uppercase font-body">
            Quick Contacts
          </h2>
          {/* <hr className="h-1 mx-72 rounded-sm" /> */}
          <div className="flex justify-center pt-2 space-x-2 ">
            {/* icon */}
            <MailIcon className="w-5 h-5" />
            {/* email id */}
            <div className="text-sm font-body">support@drivado.com</div>
          </div>
          {/* phone numbers */}
          <div className="flex flex-wrap justify-center pt-2 text-sm">
            <div className="text-center font-body mt-2">
              <div className="flex space-x-3 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body text-sm">(IN) +91 33 4004 5904,</h2>
              </div>
              <div className="flex space-x-3 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body text-sm">(IN) +91 33 4601 8734</h2>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center pt-2 text-sm">
            <div className="text-center font-body mt-2">
              <div className="flex space-x-3 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body">(GB) +44 20 3769 9669,</h2>
              </div>
              <div className="flex space-x-3 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body"> (US) +1 917 764 4544,</h2>
              </div>
            </div>
          </div>

          <div className="pt-3 text-center text-white">
            <h2 className="text-sm font-semibold text-white pt-5 font-body">
              COMPANY
            </h2>
            {/* <hr className="h-1 mx-72 rounded-sm" /> */}
            <div className="pt-2">
              <div className="footerLinks">
                <Link to="/faq">FAQ</Link>
              </div>
              <div className="footerLinks">
                <Link to="/careers">Careers</Link>
              </div>
              <div className="footerLinks">
                <Link to="/bookingConditions">Booking Conditions</Link>
              </div>
              <div className="footerLinks">
                <Link to="/termsAndConditions">Terms and Condition</Link>
              </div>
              <div className="footerLinks">
                <Link to="/privacyPolicy">Privacy Policy</Link>
              </div>
            </div>
          </div>

          <div className="pt-3 text-center text-white">
            <h2 className="text-sm font-semibold text-white pt-5 font-body">
              ADDRESS
            </h2>
            <div className="pt-2">
              <h2 className="font-body text-sm md:text-base">
                Merlin Infinite, <br />
                Unit #506, DN-51, <br />
                Street Number 11, DN Block, <br />
                Sector V, Bidhannagar, Kolkata, <br />
                West Bengal 700091, India.
              </h2>
            </div>
          </div>
        </div>

        {/* medium screen */}

        {/* ----------------------------- WEB SITE VIEW large screen ---------------------------------- */}
        <div className="hidden md:block pt-5 md:px-10 lg:px-16 xl:px-36 2xl:px-52">
          <div className="flex lg:justify-between">
            <div className="w-80">
              <Link to="/">
                <img
                  src={drivado_logo}
                  className="h-14 w-48"
                  alt="Drivado Icon"
                />
              </Link>
              <h2 className="text-slate-300 text-sm font-body font-normal my-5">
                Travel in one of our comfortable chauffeured vehicles and
                experience the sophistication of elegant luxury accompanied by
                impeccable service. You can book your transfers globally online
                around the clock.
              </h2>
              <iframe
                className="w-[300px] h-[165px] md:w-60 md:h-auto lg:w-[300px] lg:h-[165px] rounded-xl shadow-md border-[1px] border-slate-600"
                src="https://www.youtube.com/embed/3S-mKshRv_Q"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            {/* <div className="px-3 space-y-2">
          <div className="text-sm font-body font-medium uppercase text-slate-300">Quick Contacts</div>

          <div className="flex space-x-2 hover:text-secondary">
            
            <MailIcon className="w-5 h-5" />
            
            <div className="text-sm text-slate-400 font-body font-normal transition duration-300 ease-in-out cursor-pointer">support@drivado.com</div>
          </div>
          <div className="text-sm font-body text-slate-400">
            <Contact
              callcode="+91"
              phone="9903438356"
              countryflag="https://www.animatedimages.org/data/media/780/animated-india-flag-image-0009.gif"
              code="IN"
            />
            <Contact
              callcode="+1"
              phone="9177644544"
              countryflag="https://www.animatedimages.org/data/media/911/animated-usa-flag-image-0050.gif"
              code="US"
            />
            <Contact
              callcode="+44"
              code="GB"
              phone="2037699669"
              countryflag="https://www.animatedimages.org/data/media/771/animated-great-britain-flag-image-0025.gif"
            />
          </div>
        </div> */}
            <div className="px-3 text-left">
              <h2 className="font-body text-lg font-normal text-white">
                Company
              </h2>
              <div className="pt-9">
                <div>
                  <Link className="footerLinks text-slate-300" to="/faq">
                    FAQ
                  </Link>
                </div>
                <div>
                  <Link className="footerLinks text-slate-300" to="/careers">
                    Careers
                  </Link>
                </div>
                <div>
                  <Link
                    target="_blank"
                    className="footerLinks text-slate-300"
                    to="/bookingConditions"
                  >
                    Booking Conditions
                  </Link>
                </div>
                <div>
                  <Link
                    target="_blank"
                    className="footerLinks text-slate-300"
                    to="/termsAndConditions"
                  >
                    Terms and Condition
                  </Link>
                </div>
                <div>
                  <Link
                    target="_blank"
                    className="footerLinks text-slate-300"
                    to="/privacyPolicy"
                  >
                    Privacy Policy
                  </Link>
                </div>
              </div>
              <div className="md:flex items-center space-x-4 mt-5">
                <a href="#">
                  <img
                    src={require("../../assets/images/android_icon.png")}
                    alt=""
                    className="md:w-28 md:h-8 lg:w-36 lg:h-11  hover:opacity-80"
                  />
                </a>
                <a href="#">
                  <img
                    src={require("../../assets/images/ios_icon.png")}
                    alt=""
                    className="md:w-28 md:h-8 lg:w-36 lg:h-11  hover:opacity-80"
                  />
                </a>
              </div>
            </div>
            <div>
              <h2 className="font-body text-lg font-normal text-white">
                Contacts
              </h2>
              <div className="flex space-x-4 pt-4 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body text-slate-300">
                  (IN)+91 33 4004 5904
                  <br />
                  (IN)+91 33 4601 8734
                </h2>
              </div>
              <div className="flex space-x-4 pt-6 font-body">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="pt-1 text-slate-300"
                />
                <h2 className="font-body text-slate-300">
                  (GB)+44 20 3769 9669,
                  <br /> (US)+1 917 764 4544,
                </h2>
              </div>
              <div className="flex items-center space-x-4 py-5 font-body">
                <FontAwesomeIcon icon={faEnvelope} className="text-slate-300" />
                <h2 className="font-body text-slate-300">
                  support@drivado.com
                </h2>
              </div>
              <div className="flex space-x-4 font-body">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-slate-300 pt-1"
                />
                <h2 className="text-slate-300">
                  Merlin Infinite, <br />
                  Unit #506, DN-51, <br />
                  Street Number 11, DN Block, <br />
                  Sector V, Bidhannagar, Kolkata, <br />
                  West Bengal 700091, India.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:flex md:justify-between h-24 md:h-14 py-4 bg-black border-t border-slate-900 px-2 md:px-10 lg:px-16 xl:px-36 2xl:px-52">
        <h2 className="font-body text-xs sm:text-sm font-normal text-slate-300 text-center">
          © 2018-2025, Drivado Transfers Pvt Ltd. All rights reserved.
        </h2>

        {/* social media */}
        <div className="flex justify-center">
          <ul className="flex items-center space-x-5 mt-3 md:mt-0">
            <li>
              <a
                href="https://www.facebook.com/Drivado?mibextid=ZbWKwL"
                target="_blank"
                alt=""
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  className="text-white hover:text-slate-500"
                />
              </a>
            </li>
            {/* <li>
              <a href="#" target="_blank" alt="">
                <FontAwesomeIcon
                  icon={faTwitter}
                  className="text-white hover:text-slate-500"
                />
              </a>
            </li> */}
            <li>
              <a
                href="https://www.linkedin.com/company/drivado/?viewAsMember=true"
                target="_blank"
                alt=""
              >
                <FontAwesomeIcon
                  icon={faLinkedinIn}
                  className="text-white hover:text-slate-500"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/drivado_official/"
                target="_blank"
                alt=""
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  className="text-white hover:text-slate-500"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=3S-mKshRv_Q"
                target="_blank"
                alt=""
              >
                <FontAwesomeIcon
                  icon={faYoutube}
                  className="text-white hover:text-slate-500"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Footer;

const Contact = ({ callcode, phone, countryflag, code }) => {
  return (
    <div className="flex pb-1 space-x-2">
      <PhoneIcon className="w-5" />

      <div className="flex space-x-2">
        <div className="font-body">
          {callcode}&nbsp;{phone}
        </div>
        <div className="flex space-x-2">
          <img className="w-8 h-5" src={countryflag} alt="GB flag"></img>
          <div className="text-xs">({code})</div>
        </div>
      </div>
    </div>
  );
};
